export const RoutesConfig = {
  Home: {
    path: '/',
    fullPath: '/',
  },
  Auth: {
    path: 'auth/*',
    fullPath: '/auth',
  },
  RimsAuth: {
    path: 'rims-auth/*',
    fullPath: '/rims-auth',
  },
  AuthCallback: {
    path: 'callback',
    fullPath: '/auth/callback',
  },
  NotificationRedirect: {
    path: '/notifications/:id',
    basePath: '/notifications',
  },
  NotFound: {
    path: '*',
    fullPath: '/404',
  },
};
